import { render, staticRenderFns } from "./PurchaseDocumentInfo.vue?vue&type=template&id=f0b31e64&scoped=true"
import script from "./PurchaseDocumentInfo.vue?vue&type=script&lang=ts"
export * from "./PurchaseDocumentInfo.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseDocumentInfo.vue?vue&type=style&index=0&id=f0b31e64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b31e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0b31e64')) {
      api.createRecord('f0b31e64', component.options)
    } else {
      api.reload('f0b31e64', component.options)
    }
    module.hot.accept("./PurchaseDocumentInfo.vue?vue&type=template&id=f0b31e64&scoped=true", function () {
      api.rerender('f0b31e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchase/PurchaseDocumentInfo.vue"
export default component.exports